import { render, staticRenderFns } from "./BulkContentCard.vue?vue&type=template&id=7803e09b&scoped=true"
import script from "./BulkContentCard.vue?vue&type=script&lang=js"
export * from "./BulkContentCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7803e09b",
  null
  
)

export default component.exports